// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4360":"b75c3618","7477":"78eaaf57","9858":"78eaaf57"}[chunkId] + ".chunk.css";
};